// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Photos from "./pages/Photos";
import Videos from "./pages/Videos";
import "./App.css";

function App() {
  const isLoggedIn = true; // Placeholder for now

  const PasswordGate = () => (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h1>Enter Password</h1>
      <input type="password" style={{ padding: "10px", marginRight: "10px" }} />
      <button>Login</button>
    </div>
  );

  return (
    <BrowserRouter>
      <div className="App">
        {isLoggedIn ? (
          <>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/photos" element={<Photos />} />
                <Route path="/videos" element={<Videos />} />
              </Routes>
            </main>
            <Footer />
          </>
        ) : (
          <PasswordGate />
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
